module.exports = __webpack_public_path__ + "img/swiper-1.468ddc8.png";